module.exports = __webpack_public_path__ + "static/media/picture-7@2x.5e5813b1.png";